import api from "./axios";

// Firm-facing subscription status — drives the renewal/suspension banner and
// the admin Subscription page. Reachable even while the firm is suspended.
export const mySubscription = () => api.get("/my-subscription");
